import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { RouteHttpVerb } from ".";
/**
 * Get the result of the `Response`. It also handles multiline responses, e. g.
 * a PHP `Notice:` message is output through a conflicting plugin:
 *
 * If you are using a verb like `DELETE` or `PUT` the response may be empty and this
 * function will return `undefined`.
 *
 * @see https://developer.mozilla.org/de/docs/Web/HTTP/Methods/DELETE
 */

function parseResult(_x, _x2, _x3) {
  return _parseResult.apply(this, arguments);
}

function _parseResult() {
  _parseResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, result, method) {
    var cloneForFallback, body, lastError, _iterator, _step, line;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cloneForFallback = result.clone();
            _context.prev = 1;
            _context.next = 4;
            return result.json();

          case 4:
            return _context.abrupt("return", _context.sent);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            _context.next = 11;
            return cloneForFallback.text();

          case 11:
            body = _context.sent;

            if (!(body === "" && [RouteHttpVerb.DELETE, RouteHttpVerb.PUT].indexOf(method) > -1)) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", undefined);

          case 14:
            console.warn("The response of ".concat(url, " contains unexpected JSON, try to resolve the JSON line by line..."), {
              body: body
            });
            _iterator = _createForOfIteratorHelper(body.split("\n"));
            _context.prev = 16;

            _iterator.s();

          case 18:
            if ((_step = _iterator.n()).done) {
              _context.next = 30;
              break;
            }

            line = _step.value;

            if (!(line.startsWith("[") || line.startsWith("{"))) {
              _context.next = 28;
              break;
            }

            _context.prev = 21;
            return _context.abrupt("return", JSON.parse(line));

          case 25:
            _context.prev = 25;
            _context.t1 = _context["catch"](21);
            lastError = _context.t1;

          case 28:
            _context.next = 18;
            break;

          case 30:
            _context.next = 35;
            break;

          case 32:
            _context.prev = 32;
            _context.t2 = _context["catch"](16);

            _iterator.e(_context.t2);

          case 35:
            _context.prev = 35;

            _iterator.f();

            return _context.finish(35);

          case 38:
            throw lastError;

          case 39:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7], [16, 32, 35, 38], [21, 25]]);
  }));
  return _parseResult.apply(this, arguments);
}

export { parseResult };